interface ValidationRules {
  required?: RequiredType;
  minValue?: number;
  regex?: string;
  unique?: boolean;
}

interface Decoration {
  placeholder?: string;
}

export enum EditableTypes {
  EDITABLE_FOR_ALL = 'EDITABLE_FOR_ALL',
  EDITABLE_FOR_CONSUMER = 'EDITABLE_FOR_CONSUMER',
  EDITABLE_FOR_TENANT = 'EDITABLE_FOR_TENANT',
  EDITABLE_FOR_PARTNERS = 'EDITABLE_FOR_PARTNERS',
}

export interface FieldConfig {
  type:
  | 'string'
  | 'radio'
  | 'single-select'
  | 'boolean'
  | 'multi-select'
  | 'currency'
  | 'auto-complete-suggestion-text';
  title: string;
  label?: string;
  options?: string[];
  suggestion?: string[];
  display?: DisplayType[];
  initialValue?: string | number | boolean | { [key: string]: any };
  validation?: ValidationRules;
  decoration?: Decoration;
  colSpan?: number;
  infoRender?: React.ElementType;
  editable?: EditableTypes[];
}

export interface AdditionalFields {
  [key: string]: FieldConfig;
}

export enum RequiredType {
  REQUIRED_FOR_ALL = 'REQUIRED_FOR_ALL',
  REQUIRED_FOR_CONSUMER = 'REQUIRED_FOR_CONSUMER',
}

export enum DisplayType {
  // DISPLAY_FOR_ALL = 'DISPLAY_FOR_ALL', // Not supported yet
  DISPLAY_FOR_CONSUMER = 'DISPLAY_FOR_CONSUMER',
  DISPLAY_FOR_TENANT = 'DISPLAY_FOR_TENANT',
  DISPLAY_FOR_PARTNERS = 'DISPLAY_FOR_PARTNERS',
}

const AdditionalBaseConfig = {
  HOLDINGS: {
    NEW_REGISTRATION_FLOW: {
      ADDITIONAL_FIELDS: {} as AdditionalFields,
    },
  },
};

export default AdditionalBaseConfig;
